<template>
    <!-- 特殊营业时间设置 -->
    <div class="calendar-set">
        <a-form :form="form">
            <template v-for="(k,i) in form.getFieldValue('keys')">
                <div class="date-item mb8" :key="k">
                    <div class="ml16 mb8">特殊日期（{{i+1}} ）<a class="text-primary" v-if="form.getFieldValue('keys').length > 1" @click="deleteDate(k)">删除</a></div>
                    <a-form-item label="起止日期" :labelCol="{span: 3}" :wrapperCol="{span: 10}">
                        <a-range-picker style="width: 100%;" v-decorator="['date'+k,{rules: [{required: true, message: '请选择起止日期'}]}]" />
                    </a-form-item>
                    <a-form-item label="开闭店状态" required :labelCol="{span: 3}" :wrapperCol="{span: 10}">
                        <a-radio-group v-decorator="['businessState'+k,{initialValue:1}]" @change="onChangebusinessState($event,k)" >
                            <a-radio :value="1">开店</a-radio>
                            <a-radio :value="0">闭店</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="营业时间" v-show="isShow[k]" required :labelCol="{span: 3}" :wrapperCol="{span: 10}" style="margin-bottom: 0">
                        <a-input-group compact>
                            <a-form-item class="group-left" style="display: inline-block; width: 45%;">
                                <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['startTime'+k,{rules: [{required: isShow[k], message: '请选择开始营业时间'}]}]" placeholder="开始营业时间">
                                    <span slot="suffixIcon"></span>
                                </a-time-picker>
                            </a-form-item>
                            <a-input
                                style="width: 10%; border-left: 0;border-right: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-form-item class="group-right" style="display: inline-block; width: 45%;">
                                <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['endTime'+k,{rules: [{required: isShow[k], message: '请选择结束营业时间'}]}]" placeholder="结束营业时间"></a-time-picker>
                            </a-form-item>
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="说明" :labelCol="{span: 3}" :wrapperCol="{span: 10}">
                        <a-input v-decorator="['remark'+k,{rules: [{ message: '请输入(50字以内)',max: 50}]}]" placeholder="请输入（0-50字）" />
                    </a-form-item>
                    <a-button @click="addDate" v-if="i === form.getFieldValue('keys').length -1" shape="round" icon="plus" class="mb16">增加特殊日期</a-button>
                </div>
            </template>
        </a-form>
        <div class="mt24 shop-list">
            <div class="mb16">规则适用门店</div>
            <div v-if="suitShopId == -1">
                <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                    全部门店
                </a-checkbox>
                <br/>
                <a-checkbox-group v-model="checkedList" :options="shopList" @change="onChange" />
            </div>
            <div v-else>{{suitShopName}}</div>
        </div>
        <div class="text-center mt32">
            <a-button @click="$router.go(-1)">取消</a-button>
            <a-button type="primary" @click="batchSetDate">提交</a-button>
        </div>
    </div>
</template>
<script>
let key = 0;
    import { mapGetters } from "vuex";

export default {
    data() {
        return {
            checkedList: [],
            indeterminate: false,
            checkAll: false,
            shopList: [],
            isShow: {0: true},
            suitShopId: this.$route.query.shopId,
            suitShopName: this.$route.query.shopName,
        }
    },
    computed: {
        ...mapGetters(["shopId","shopName"])
    },
    methods: {
        onChange(checkedList) {
            this.indeterminate = !!checkedList.length && checkedList.length < this.shopList.length;
            this.checkAll = checkedList.length === this.shopList.length;
        },
        onCheckAllChange(e) {
            let checkedList = [];
            if(e.target.checked) {
                this.shopList.forEach(item => {
                    checkedList.push(item.value)
                })
            }
            Object.assign(this, {
                checkedList: checkedList,
                indeterminate: false,
                checkAll: e.target.checked,
            });
        },
        onChangebusinessState(event,k) {
            this.isShow[k] = event.target.value === 1;
        },
		/**
		 * @getAllShopList 获取所有门店列表
		 */
		getAllShopList() {
            this.shopList = [];
			this.$api.totalPlatform.selectList({}).then(res => {
                res.forEach(item => {
                    this.shopList.push({
                        label: item.name,
                        value: item.id
                    })
                })
			});
		},
        addDate() {
            const { form } = this;
            const keys = form.getFieldValue('keys');
            const nextKeys = keys.concat(++key);
            this.isShow[key] = true;
            form.setFieldsValue({
                keys: nextKeys,
            });
        },
        deleteDate(k) {
            const { form } = this;
            const keys = form.getFieldValue('keys');
            if (keys.length === 1) {
                return;
            }
            form.setFieldsValue({
                keys: keys.filter(key => key !== k),
            });
        },
        batchSetDate() {
            let _this = this;
            _this.form.validateFields((err, values) => {
                if (err) return;
                let flag = 0;
                values.keys.forEach(k => {
                    if(!_this.isShow[k]) {
                        flag++
                    }
                    flag = values['startTime'+k] < values['endTime'+k] ? flag + 1 : flag;
                })
                if(flag < values.keys.length) {
                    _this.$message.error('结束营业时间需大于开始营业时间，请重新选择')
                    return
                }
                if(_this.suitShopId == -1 && _this.checkedList.length === 0) {
                    this.$message.error('请勾选适用门店');
                    return
                }
                _this.$confirm({
                    title: '是否确认提交？',
                    content: '提交后最新的日期类型将立即生效',
                    centered: true,
                    onOk() {
                        let businessHoursSetOneDtos = [];
                        values.keys.forEach(k => {
                            businessHoursSetOneDtos.push({
                                businessHoursDateStart: _this.$moment(values['date'+k][0]).format('YYYY-MM-DD'),
                                businessHoursDateEnd: _this.$moment(values['date'+k][1]).format('YYYY-MM-DD'),
                                businessState: values['businessState'+k],
                                remark: values['remark'+k],
                                businessHoursTimeRangeDtos: [{
                                    startTime: _this.isShow[k] ? _this.$moment(values['startTime'+k]).format('HH:mm') : '',
                                    endTime: _this.isShow[k] ? _this.$moment(values['endTime'+k]).format('HH:mm') : '',
                                }],
                            })
                        })
                        _this.$api.totalPlatform.batchSetBusinessHours({
                            body: {
                                businessHoursSetOneDtos: businessHoursSetOneDtos,
                                suitShopIdList: _this.suitShopId == -1 ? _this.checkedList : [_this.suitShopId]
                            }
                        }).then(res => {
                            _this.$message.success('操作成功');
                            _this.$router.go(-1);
                        });
                    },
                    onCancel() {},
                });
            });
        },

    },
    mounted() {
        this.getAllShopList()
        this.suitShopId = this.$route.query.id;
        this.suitShopName = this.$route.query.shopName;
    },
    beforeCreate() {
        key = 0;
        this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
        this.form.getFieldDecorator('keys', { initialValue: [key], preserve: true });
    },
    watch: {
        shopId(val) {
            this.suitShopId = val;
        },
        shopName(val) {
            this.suitShopName = val;
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.calendar-set {
    background-color: #fff;
    margin: 24px;
    padding: 24px;
    .date-item {
        border-bottom: 1px solid #e9e9e9;
    }
    .shop-list {
        .ant-checkbox-wrapper {
            margin-bottom: 8px;
        }
    }

    .group-right {
        .ant-time-picker-input {
            border-left: none;
            border-radius: 0 4px 4px 0;
        }
    }
}
</style>
